module.exports = __webpack_public_path__ + "static/media/Thomas Brady.fa3105d5.png";